const defaultState = function () {
  return {
    tableSetList: [{}],
    tdLists: [],
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchConditions: {
      customerType: {
        type: 'MultiSelector',
        title: 'バッチ種別',
        property: '',
        display: false,
        value: '',
        options: [
          { code: 1, name: '夜間' },
          { code: 2, name: '随時' }
        ]
      }
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}
